var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportRail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e0315a4c-3917-4591-911a-257a7142432f",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.56 198.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a4ecda8f-8a10-443f-af97-df1f158aa35b",
    "data-name": "HU18YV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.66,355.08H289.54c-.43-.25-.85-.53-1.3-.74q-14.82-6.84-29.63-13.67T229,326.92c-13.16-6.09-26.34-12.13-39.46-18.28a23.48,23.48,0,0,0-10.39-2.48c-25,.15-50.08.08-75.12.07-.77,0-1.55-.07-2.33-.12V273.58c24,0,47.92,0,71.89.08a20.36,20.36,0,0,0,9.13-2c14.11-6.69,28.27-13.27,42.4-19.9q15.23-7.14,30.44-14.31l6.14-2.91-.11-.37H104.39c-.89,0-1.78-.07-2.67-.12V202.81H261.59l.11-.43L158.08,157.06c.55-.1.66-.14.77-.14q36.39,0,72.77,0a4.47,4.47,0,0,1,1.77.35c2.86,1.26,5.69,2.57,8.52,3.89,7.08,3.3,14.14,6.63,21.23,9.91q23.16,10.71,46.33,21.38c7,3.23,13.95,6.51,20.95,9.72a7.21,7.21,0,0,0,2.9.6q38.48,0,77,0V234c-.78.05-1.56.12-2.33.12q-37.05,0-74.11,0a8,8,0,0,0-3.09.49c-2.61,1.11-5.16,2.4-7.72,3.64-7.07,3.44-14.12,6.92-21.2,10.34q-24.25,11.73-48.52,23.43c-.82.4-1.62.81-2.43,1.22a2.06,2.06,0,0,0,1.21.35H369.9q20.19,0,40.38,0v32.53a8.36,8.36,0,0,1-1,.12h-27l-126.22,0a2.91,2.91,0,0,0-.74.29c4.21,1.9,8.16,3.68,12.12,5.45q13,5.82,25.94,11.61,18,8,36,16,12.13,5.41,24.27,10.85C357,352,360.34,353.54,363.66,355.08Z",
    transform: "translate(-101.72 -156.92)",
    style: {
      fill: "#db3a3a"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportRail);
export default __webpack_public_path__ + "static/media/transport-rail.380e7cf3.svg";
export { ForwardRef as ReactComponent };